// API
import { api } from '../configs/api/api';

// Models
import {
  ICompanyPermissionSettings,
  ICompanyPermissionSettingWorker, IWorkerPermissionRequest
} from '../interfaces/permission-settings.interfaces';

export const PermissionSettingsService = {
  fetchPermissionSettings: async (): Promise<{
    company_permission_settings?: ICompanyPermissionSettings,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.get('/company/permission-settings/get-settings');
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchWorkersPermissionSettings: async (offset: number = 0, limit: number = 6): Promise<{
    company_permission_setting_workers?: ICompanyPermissionSettingWorker[],
    total?: number,
    total_all?: number,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.get('/company/permission-settings/workers', {
        params: {
          offset, limit
        }
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateCompanyPermissionSettings: async (company_permission_settings: ICompanyPermissionSettings): Promise<{
    company_permission_settings?: ICompanyPermissionSettings,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/permission-settings/update-company-settings', {
        ...company_permission_settings,
        is_anonymity_enabled: !!company_permission_settings?.is_anonymity_enabled
      });
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  updateWorkersPermissionSettings: async (data: IWorkerPermissionRequest): Promise<{
    company_permission_setting_workers?: ICompanyPermissionSettingWorker,
    error?: string
  }> => {
    try {
      const axiosResponse = await api.post('/company/permission-settings/update-worker-settings', data);
      return axiosResponse.data;
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },

}
